<template>
    <div class="paas-designer-empty" draggable="false">
        <div class="paas-designer-empty--inner">
            <svg-icon name="empty" :style="iconStyle" />
            <span class="paas-designer--tip">
                <slot name="tip">
                    <span>{{ tip }}</span>
                </slot>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PaasEmpty',
    props: {
        tip: {
            type: String,
            default: '暂无数据',
        },
    },
    computed: {
        iconStyle() {
            return {
                fontSize: '56px',

            }
        },
    },
}
</script>

<style lang="less" scoped>
.paas-designer{
    display: inline-block;
    &-empty{
        &--inner{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
        }
    }
   
    &--tip{
      color: #ccc;
      margin-top: 24px;
    }
}
</style>
